import { Grid } from "@mui/material";
import { PlaceholderLine } from "modules/common/components/layout";

export function TwoFactorSettingsSectionPlaceholder() {
    return (
        <Grid className="two-factor-settings-section">
            <Grid item xs={12}>
                <div className="two-factor-settings-card-container">
                    <PlaceholderLine color="dark" thickness="thick" />
                </div>
                <div className="two-factor-settings-card-container">
                    <PlaceholderLine color="dark" thickness="thin" />
                </div>
                <div className="two-factor-settings-card-container">
                    <PlaceholderLine color="light" thickness="thick" />
                </div>
            </Grid>
        </Grid>
    );
}
